module.exports = __webpack_public_path__ + "static/media/ug.ef569370.svg";